import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/sonner';
import { store } from './store';
import AppRoutes from './routes/AppRoutes';
import ThemeProvider from './ThemeProvider';
import Header from './components/Header';
import BottomNavigation from './components/BottomNavigation';
import AuthWrapper from './components/auth/AuthWrapper';

export default function App() {
  return (
    <ReduxProvider store={store}>
      <ThemeProvider>
        <TooltipProvider delayDuration={200}>
          <BrowserRouter>
            <AuthWrapper>
              <Header />
              <div className="min-h-screen bg-background">
                <AppRoutes />
              </div>
              <BottomNavigation />
            </AuthWrapper>
          </BrowserRouter>
          <Toaster />
        </TooltipProvider>
      </ThemeProvider>
    </ReduxProvider>
  );
}

